import classNames from 'classnames';
import { useCallback, useMemo, useRef, useState } from 'react';
import styles from './FJSelectWithSearch.module.less';
import PropTypes from 'prop-types';
import FJUtil from '../../../../util/FJUtil';
import FJDropDown from '../../../../common/components/FJDropDown/FJDropDown';
import FJVerticalScroller from '../../../../common/components/FJScroller/FJVerticalScroller';
import FJCheckIcon from '../../../../assets/svg/textToVideo/choose.svg?react';
import FJArrowUpDownIcon from '../../../../assets/svg/textToVideo/button-pull-down.svg?react';
import FJLocalStore from '../../../../store/FJLocalStore';
import FJNoResults from '../FJNoResult/FJNoResults';
import FJSearchContainer from '../../../../common/components/FJSearch/FJSearchContainer';
const FJSelectWithSearch = props => {
    const {
        list,
        onLanguageValueChange,
        value,
        jsonKey,
        jsonValue,
        widthStyle,
        placeHolder = '',
        isEmptyWarning = false,
        zIndex,
    } = props;
    const [searchValue, setSearchValue] = useState('');

    const searchRef = useRef(null);
    const dropMenuRef = useRef(null);
    const scrollRef = useRef(null);
    const selectItemObjRef = useRef({});

    /**
     * @description 输入框的值改变
     * @param value
     */
    const onValueChange = useCallback(
        value => {
            setSearchValue(value);
            scrollRef.current.scrollTop(0);
        },
        [scrollRef.current],
    );

    const onLanguageValueClick = value => {
        onLanguageValueChange(value);
        dropMenuRef.current.hide();
    };

    const autoPosition = useCallback(() => {
        const scrollNode = scrollRef.current.getScroller();
        const selectNode = selectItemObjRef.current[value];
        if (selectNode) {
            const scrollTop = scrollNode.scrollTop;
            const offsetHeight = scrollNode.offsetHeight;
            const selectNodeOffsetTop = selectNode.offsetTop; // offsetTop：元素到offsetParent顶部的距离  offsetParent：距离元素最近的一个具有定位的祖宗元素（relative，absolute，fixed），若祖宗都不符合条件，offsetParent为body, 所以需要有定位属性
            const selectedBottomOffsetBottom = selectNode.offsetHeight + selectNodeOffsetTop;
            // if (selectNodeOffsetTop < scrollTop || selectedBottomOffsetBottom > scrollTop + offsetHeight) {
            // }
            if (selectNodeOffsetTop < scrollTop) {
                scrollRef.current.scrollTop(selectNodeOffsetTop);
            }
            if (selectedBottomOffsetBottom > scrollTop + offsetHeight) {
                scrollRef.current.scrollTop(scrollTop + (selectedBottomOffsetBottom - (scrollTop + offsetHeight)));
            }
        }
    }, [scrollRef.current, selectItemObjRef.current, value]);

    /**
     * @description 下拉框展开的时候
     */
    const onDropdownShow = () => {
        searchRef.current.focus();
        autoPosition();
    };

    const onDropdownHide = () => {
        // setSearchValue('');
    };

    const useShowList = useMemo(() => {
        return FJUtil.filterLanguageList(list, searchValue, jsonValue);
    }, [searchValue, list]);

    const scrollHeight = useMemo(() => {
        if (useShowList.length === 0) {
            return 'auto';
        } else if (useShowList.length > 6) {
            return 6 * 40 + 3;
        } else {
            return useShowList.length * 40 + 3;
        }
    }, [useShowList]);

    const showLanguageName = useMemo(() => {
        const itemInfo = list.find(item => item[jsonKey || 'value'] === value);
        if (itemInfo) {
            return itemInfo[jsonValue || 'languageKey'];
        }
    }, [value, list]);

    return (
        <FJDropDown
            overlay={
                <div className={styles.overlay} style={widthStyle}>
                    <FJSearchContainer
                        ref={searchRef}
                        theme='theme-mini'
                        isElement={false}
                        style={{ height: 42, border: 'none', top: 0 }}
                        className={styles.search}
                        onChange={onValueChange}
                        search={() => {}}
                        placeHolder={FJLocalStore._('search-for-languages')}
                    />
                    <FJVerticalScroller style={{ height: scrollHeight }} ref={scrollRef}>
                        {useShowList.length > 0 ? (
                            <ul className={styles.list}>
                                {useShowList.map((item, index) => {
                                    return (
                                        <li
                                            className={classNames(styles.li_item, 'ellipsis')}
                                            key={index + item[jsonKey || 'value']}
                                            onClick={() => {
                                                onLanguageValueClick(item[jsonKey || 'value']);
                                            }}
                                            ref={ele => (selectItemObjRef.current[item[jsonKey || 'value']] = ele)}
                                        >
                                            {FJLocalStore._(item[jsonValue || 'languageKey'])}
                                            {value === item[jsonKey || 'value'] ? (
                                                <FJCheckIcon className={styles.check_icon} />
                                            ) : null}
                                        </li>
                                    );
                                })}
                            </ul>
                        ) : (
                            <div className={styles.no_option}>
                                <FJNoResults keywords={searchValue} className={styles.no_result} />
                            </div>
                        )}
                    </FJVerticalScroller>
                </div>
            }
            overlayStyle={{
                position: 'fixed',
            }}
            hasArrow={false}
            triggerDisplay='flex'
            propsTop={-2}
            onShow={onDropdownShow}
            ref={dropMenuRef}
            onHide={onDropdownHide}
            zIndex={zIndex}
            placement='bottomLeft'
        >
            <div className={classNames(styles.trigger, isEmptyWarning ? styles.warning : '')} style={widthStyle}>
                <div className={styles.text}>{showLanguageName && FJLocalStore._(showLanguageName)}</div>
                {placeHolder && !showLanguageName && <span className={styles.placeholder}>{placeHolder}</span>}
                <FJArrowUpDownIcon />
            </div>
        </FJDropDown>
    );
};

FJSelectWithSearch.propTypes = {
    list: PropTypes.array.isRequired,
    onLanguageValueChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
    jsonKey: PropTypes.string,
    jsonValue: PropTypes.string,
    widthStyle: PropTypes.object,
    placeHolder: PropTypes.string,
    isEmptyWarning: PropTypes.bool,
    zIndex: PropTypes.number,
};
export default FJSelectWithSearch;
